import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from '../store'

Vue.use(VueRouter)

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

const router = new VueRouter({
    // mode: 'history',
    routes: [
        {
            path: '/login',
            component: () => import('./../components/login.vue')
        },
        {
            path: '/',
            name: 'home',
            meta: {
                requireAuth: true
            },
            redirect: '/user',
            component:  () => import('./../components/home.vue'),
            children: [
                {
                    path: '/user',
                    name: 'user',
                    meta: {
                        requireAuth: true
                    },
                    component: () => import('./../components/user.vue')
                },
                {
                    path: '/devices',
                    name: 'devices',
                    meta: {
                        requireAuth: true
                    },
                    component: () => import('./../components/devices.vue')
                },
                {
                    path: '/admin',
                    name: 'admin',
                    meta: {
                        requireAuth: true
                    },
                    component: () => import('./../components/admin.vue')
                }
            ]
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth) {
        if (sessionStorage.token) {
            next();
        } else {
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    } else {
        next();
    }
})

export default router;